<template>
    <b-modal
      v-model="isModalOpen"
      size="lg"
      @hidden="closeModal"
      hide-header
      hide-footer
    >
      <div class="custom-modal-header d-flex justify-content-between align-items-center" style="padding: 20px">
        <h5 class="modal-title font-16">{{ company }}</h5>
        <button 
          type="button" 
          class="close" 
          @click="closeModal"
          aria-label="Close"
          style="margin-right: 40px"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="jd-details" style="">
        <div class="jd-section jd-title-section">
          <h3>{{ jd.job_title }}</h3>
        </div>
  
        <div class="jd-section jd-info-section">
          <p v-html="jd.job_description"></p>
        </div>
      </div>
  
      <div class="custom-modal-footer" v-if="!isOtherNotifications">
          <b-button 
              class="custom-btn"
              style="background-color: #6C757D;"
              disabled
          >今回は控える</b-button>
          <b-button 
              v-if="isQuestionRequest"
              class="custom-btn"
              style="background-color: #2F80ED;"
              disabled
          >質問する</b-button>
          <b-button 
              variant="secondary" 
              class="custom-btn"
              style="background-color: #006C6B;"
              disabled
              v-html="submitButtonText"
          ></b-button>
          </div>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'IndividualJDModal',
    
    props: {
      jd: {
        type: Object,
        required: true,
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      submitButtonText: {
        type: String,
        required: true
      },
      isOtherNotifications: {
        type: Boolean,
        default: false
      },
      isQuestionRequest: {
        type: Boolean,
        default: false
      },
      company: {
        type: String,
        required: true
      }
    },

    computed: {
      isModalOpen: {
        get() {
          return this.isOpen
        },
        set(value) {
          if (!value) {
            this.closeModal()
          }
        }
      }
    },

    methods: {
      closeModal() {
        this.$emit('closeJdModal')
      },
    },
  }
  </script>
  
  <style scoped>
  ::v-deep .modal-body {
      padding: 0px !important;
  }
  .font-16 {
      font-size: 16px;
  }
  .jd-section {
      text-align: left;
      padding: 30px 50px;
  }

  .jd-title-section {
      background: #ededed;
      height: 76px;
      padding: 30px 20px;
  }

  .jd-info-section {
      max-height: 450px;
      overflow-y: auto;
      padding: 20px;
  }

  .jd-info-section p {
      font-size: 12px;
  }

  .jd-section h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 14px;
  }

  .company {
    color: #666;
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }

  .custom-modal-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 2rem;
    background-color: #F2F5F7;
    border-top: 1px solid #dee2e6;
  }

  .custom-btn {
    border-radius: 0 !important;  /* Makes buttons rectangular */
    min-width: 200px;  /* Optional: ensures consistent button width */
    padding: 0.5rem 1rem;
  }

  .custom-btn:disabled {
      opacity: 1;
  }

  </style>
  